import s from './style.module.css';
import FormHelperText from '@mui/material/FormHelperText';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';

type Option = {
  value: string | number;
  label?: string | null;
  etage?: string;
  area?: string | null;
  subArea?: string | null;
  devEui?: string | null;
  dev?: string | null;
  eui?: string | null;
};

type InputType = {
  label?: string;
  options: Option[];
  value: Option | Option[] | null;
  placeholder?: string;
  error?: boolean;
  disabled?: boolean;
  errorMessage?: string;
  multiple?: boolean;
  loading?: boolean;
  OnChange?: (value: Option | Option[] | null) => void;
  open?: boolean;
  onClose?: () => void;
  onOpen?: () => void;
  displayOption?: (props: any, option: Option) => JSX.Element;
  handleReachEnd?: (event: any) => void;
  isOptionEqualToValue?: (option: Option, value: Option) => boolean;
};

const SelectSearch = ({
  label,
  options,
  value,
  disabled,
  errorMessage,
  multiple = false,
  loading,
  OnChange,
  displayOption,
  handleReachEnd,
  isOptionEqualToValue,
  onOpen,
  onClose,
}: InputType) => {
  const { t } = useTranslation();

  const normalizedValue = multiple
    ? Array.isArray(value)
      ? value
      : []
    : Array.isArray(value)
    ? null
    : value ?? null;
  return (
    <>
      {label && <FormHelperText className={s.label}>{label}</FormHelperText>}

      <Autocomplete<Option, boolean, false, false>
        multiple={multiple}
        className={s.selectSearch}
        id="controller-selector"
        disabled={disabled}
        options={options}
        value={normalizedValue}
        loading={loading}
        filterSelectedOptions
        onChange={(_, newValue) => OnChange?.(newValue)}
        // onChange={(_, newValue) => console.log('newValue', newValue)}
        // isOptionEqualToValue={
        //   isOptionEqualToValue ?? ((option, val) => option.value === val.value)
        // }
        isOptionEqualToValue={(option, val) => {
          if (option == null || val == null) return false;

          return String(option.value) === String(val.value);
        }}
        onOpen={onOpen}
        onClose={onClose}
        getOptionLabel={(option) =>
          option?.label ?? option?.value?.toString() ?? ''
        }
        renderOption={(props, option) => {
          if (displayOption) {
            return displayOption(props, option);
          }

          return <li {...props}>{option.label ?? option.value}</li>;
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={t('controller-select')}
            error={!!errorMessage}
            helperText={errorMessage}
          />
        )}
        {...(handleReachEnd && {
          ListboxProps: {
            onScroll: handleReachEnd,
          },
        })}
      />
    </>
  );
};

export default SelectSearch;
